<template>
  <div class="dialog page-dialog">
    <div class="container">
      <div class="dialog-header">{{ ts('Payment Result')['Payment Result'] }}</div>
      <div class="dialog-content">
        <div class="pay-status">
          <div class="icon-svg">
            <svg viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="页面-1" stroke="none" stroke-width="1" fill-rule="evenodd">
                <g id="table-right" fill-rule="nonzero">
                  <circle id="椭圆形" cx="10.58" cy="10.58" r="10.58"></circle>
                  <polygon id="路径" fill="#FFFFFF" points="3.06 10.92 5.34 9.04 8.16 11.86 15.83 4.6 18.11 6.89 8.57 16.57"></polygon>
                </g>
              </g>
            </svg>
          </div>
          <div class="title">{{ ts('Payment successful !')['Payment successful !'] }}</div>
          <p>{{ ts('You can check the reservation detail and receipt on your account page')['You can check the reservation detail and receipt on your account page'] }}</p>
        </div>
        <div class="dialog-footer">
          <el-button type="primary" class="btn btn-theme" @click="$router.push('/user')">{{ ts('MY ACCOUNT')['MY ACCOUNT'] }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LanguagePackage } from '@/mixins/LanguagePackage'
export default {
  name: 'PaySuccess',
  mixins: [LanguagePackage],
  data() {
    return {}
  },
  methods: {},
}
</script>

<style scoped lang="sass"></style>
